import { Routes } from '@angular/router';
import { InputDocComponent } from './pages/atoms/input-doc.component';
import { DateInputDocComponent } from './pages/atoms/date-input-doc.component';
import { PhoneInputDocComponent } from './pages/atoms/phone-input-doc.component';
import { SelectDocComponent } from './pages/atoms/select-doc.component';
import { MultiselectDocComponent } from './pages/atoms/multiselect-doc.component';
import { CheckboxDocComponent } from './pages/atoms/checkbox-doc.component';
import { SwitchDocComponent } from './pages/atoms/switch-doc.component';
import { TextareaDocComponent } from './pages/atoms/textarea-doc.component';
import { RichEditorDocComponent } from './pages/atoms/rich-editor-doc.component';
import { RadioDocComponent } from './pages/atoms/radio-doc.component';
import { TooltipDocComponent } from './pages/atoms/tooltip-doc.component';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./shell/shell.component').then((m) => m.ShellComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'foundations' },
      {
        path: 'foundations',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/foundations/foundations-overview.component').then(
                (m) => m.FoundationsOverviewComponent,
              ),
          },
          {
            path: 'font',
            loadComponent: () =>
              import('./pages/foundations/font-doc.component').then(
                (m) => m.FontDocComponent,
              ),
          },
          {
            path: 'scrollbar',
            loadComponent: () =>
              import('./pages/foundations/scrollbar-doc.component').then(
                (m) => m.ScrollbarDocComponent,
              ),
          },
        ],
      },
      {
        path: 'atoms',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/atoms/atoms-overview.component').then(
                (m) => m.AtomsOverviewComponent,
              ),
          },
          {
            path: 'message',
            loadComponent: () =>
              import('./pages/atoms/message-doc.component').then(
                (m) => m.MessageDocComponent,
              ),
          },
          {
            path: 'button',
            loadComponent: () =>
              import('./pages/atoms/button-doc.component').then(
                (m) => m.ButtonDocComponent,
              ),
          },
          {
            path: 'icon-action',
            loadComponent: () =>
              import('./pages/atoms/icon-action-doc.component').then(
                (m) => m.IconActionDocComponent,
              ),
          },
          {
            path: 'breadcrumb',
            loadComponent: () =>
              import('./pages/atoms/breadcrumb-doc.component').then(
                (m) => m.BreadcrumbDocComponent,
              ),
          },
          {
            path: 'avatar',
            loadComponent: () =>
              import('./pages/atoms/avatar-doc.component').then(
                (m) => m.AvatarDocComponent,
              ),
          },
          {
            path: 'input',
            component: InputDocComponent,
          },
          {
            path: 'identity-photo-capture',
            loadComponent: () =>
              import('./pages/atoms/identity-photo-capture-doc.component').then(
                (m) => m.IdentityPhotoCaptureDocComponent,
              ),
          },
          {
            path: 'selfie-capture',
            loadComponent: () =>
              import('./pages/atoms/selfie-capture-doc.component').then(
                (m) => m.SelfieCaptureDocComponent,
              ),
          },
          {
            path: 'date-input',
            component: DateInputDocComponent,
          },
          {
            path: 'phone-input',
            component: PhoneInputDocComponent,
          },
          {
            path: 'select',
            component: SelectDocComponent,
          },
          {
            path: 'multiselect',
            component: MultiselectDocComponent,
          },
          {
            path: 'checkbox',
            component: CheckboxDocComponent,
          },
          {
            path: 'code-input',
            loadComponent: () =>
              import('./pages/atoms/code-input-doc.component').then(
                (m) => m.CodeInputDocComponent,
              ),
          },
          {
            path: 'switch',
            component: SwitchDocComponent,
          },
          {
            path: 'textarea',
            component: TextareaDocComponent,
          },
          {
            path: 'rich-editor',
            component: RichEditorDocComponent,
          },
          {
            path: 'radio',
            component: RadioDocComponent,
          },
          {
            path: 'recaptcha',
            loadComponent: () =>
              import('./pages/atoms/recaptcha-doc.component').then(
                m => m.RecaptchaDocComponent,
              ),
          },
          {
            path: 'tooltip',
            component: TooltipDocComponent,
          },
          {
            path: 'whatsapp-fab',
            loadComponent: () =>
              import('./pages/atoms/whatsapp-fab-doc.component').then(
                (m) => m.WhatsappFabDocComponent,
              ),
          },
          {
            path: 'nav-select',
            loadComponent: () =>
              import('./pages/atoms/nav-select-doc.component').then(
                (m) => m.NavSelectDocComponent,
              ),
          },
          {
            path: 'tag',
            loadComponent: () =>
              import('./pages/atoms/tag-doc.component').then(
                (m) => m.TagDocComponent,
              ),
          },
          {
            path: 'day-strip',
            loadComponent: () =>
              import('./pages/atoms/day-strip-doc.component').then(
                (m) => m.DayStripDocComponent,
              ),
          },
          {
            path: 'icon-tab-bar',
            loadComponent: () =>
              import('./pages/atoms/icon-tab-bar-doc.component').then(
                (m) => m.IconTabBarDocComponent,
              ),
          },
          {
            path: 'flow-label',
            loadComponent: () =>
              import('./pages/atoms/flow-label-doc.component').then(
                (m) => m.FlowLabelDocComponent,
              ),
          },
          {
            path: 'flow-marker',
            loadComponent: () =>
              import('./pages/atoms/flow-marker-doc.component').then(
                (m) => m.FlowMarkerDocComponent,
              ),
          },
          {
            path: 'flow-connector',
            loadComponent: () =>
              import('./pages/atoms/flow-connector-doc.component').then(
                (m) => m.FlowConnectorDocComponent,
              ),
          },
          {
            path: 'flow-node-frame',
            loadComponent: () =>
              import('./pages/atoms/flow-node-frame-doc.component').then(
                (m) => m.FlowNodeFrameDocComponent,
              ),
          },
        ],
      },
      {
        path: 'molecules',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/molecules/molecules-overview.component').then(
                (m) => m.MoleculesOverviewComponent,
              ),
          },
          {
            path: 'avatar-group',
            loadComponent: () =>
              import('./pages/molecules/avatar-group-doc.component').then(
                (m) => m.AvatarGroupDocComponent,
              ),
          },
          {
            path: 'filter-menu',
            loadComponent: () =>
              import('./pages/molecules/filter-menu-doc.component').then(
                (m) => m.FilterMenuDocComponent,
              ),
          },
          {
            path: 'segmented-filter',
            loadComponent: () =>
              import('./pages/molecules/segmented-filter-doc.component').then(
                (m) => m.SegmentedFilterDocComponent,
              ),
          },
          {
            path: 'file-upload',
            loadComponent: () =>
              import('./pages/molecules/file-upload-doc.component').then(
                (m) => m.FileUploadDocComponent,
              ),
          },
          {
            path: 'media-upload',
            loadComponent: () =>
              import('./pages/molecules/media-upload-doc.component').then(
                (m) => m.MediaUploadDocComponent,
              ),
          },
          {
            path: 'notification-menu',
            loadComponent: () =>
              import('./pages/molecules/notification-menu-doc.component').then(
                (m) => m.NotificationMenuDocComponent,
              ),
          },
          {
            path: 'form-section',
            loadComponent: () =>
              import('./pages/molecules/form-section-doc.component').then(
                (m) => m.FormSectionDocComponent,
              ),
          },
          {
            path: 'list-report',
            loadComponent: () =>
              import('./pages/molecules/list-report-doc.component').then(
                (m) => m.ListReportDocComponent,
              ),
          },
          {
            path: 'compact-list',
            loadComponent: () =>
              import('./pages/molecules/compact-list-doc.component').then(
                (m) => m.CompactListDocComponent,
              ),
          },
          {
            path: 'contact-card',
            loadComponent: () =>
              import('./pages/molecules/contact-card-doc.component').then(
                (m) => m.ContactCardDocComponent,
              ),
          },
          {
            path: 'indicator-card',
            loadComponent: () =>
              import('./pages/molecules/indicator-card-doc.component').then(
                (m) => m.IndicatorCardDocComponent,
              ),
          },
          {
            path: 'loading-modal',
            loadComponent: () =>
              import('./pages/molecules/loading-modal-doc.component').then(
                (m) => m.LoadingModalDocComponent,
              ),
          },
          {
            path: 'drawer',
            loadComponent: () =>
              import('./pages/molecules/drawer-doc.component').then(
                (m) => m.DrawerDocComponent,
              ),
          },
          {
            path: 'user-profile-menu',
            loadComponent: () =>
              import('./pages/molecules/user-profile-menu-doc.component').then(
                (m) => m.UserProfileMenuDocComponent,
              ),
          },
          {
            path: 'welcome-user-panel',
            loadComponent: () =>
              import('./pages/molecules/welcome-user-panel-doc.component').then(
                (m) => m.WelcomeUserPanelDocComponent,
              ),
          },
          {
            path: 'task-item',
            loadComponent: () =>
              import('./pages/molecules/task-item-doc.component').then(
                (m) => m.TaskItemDocComponent,
              ),
          },
          {
            path: 'signature-pad',
            loadComponent: () =>
              import('./pages/molecules/signature-pad-doc.component').then(
                (m) => m.SignaturePadDocComponent,
              ),
          },
          {
            path: 'flow-process-node',
            loadComponent: () =>
              import('./pages/molecules/flow-process-node-doc.component').then(
                (m) => m.FlowProcessNodeDocComponent,
              ),
          },
          {
            path: 'flow-terminator-node',
            loadComponent: () =>
              import('./pages/molecules/flow-terminator-node-doc.component').then(
                (m) => m.FlowTerminatorNodeDocComponent,
              ),
          },
          {
            path: 'flow-document-node',
            loadComponent: () =>
              import('./pages/molecules/flow-document-node-doc.component').then(
                (m) => m.FlowDocumentNodeDocComponent,
              ),
          },
          {
            path: 'flow-decision-node',
            loadComponent: () =>
              import('./pages/molecules/flow-decision-node-doc.component').then(
                (m) => m.FlowDecisionNodeDocComponent,
              ),
          },
          {
            path: 'flow-connector-node',
            loadComponent: () =>
              import('./pages/molecules/flow-connector-node-doc.component').then(
                (m) => m.FlowConnectorNodeDocComponent,
              ),
          },
          {
            path: 'flow-off-page-node',
            loadComponent: () =>
              import('./pages/molecules/flow-off-page-node-doc.component').then(
                (m) => m.FlowOffPageNodeDocComponent,
              ),
          },
          {
            path: 'flow-io-node',
            loadComponent: () =>
              import('./pages/molecules/flow-io-node-doc.component').then(
                (m) => m.FlowIoNodeDocComponent,
              ),
          },
          {
            path: 'flow-note-node',
            loadComponent: () =>
              import('./pages/molecules/flow-note-node-doc.component').then(
                (m) => m.FlowNoteNodeDocComponent,
              ),
          },
          {
            path: 'flow-path',
            loadComponent: () =>
              import('./pages/molecules/flow-path-doc.component').then(
                (m) => m.FlowPathDocComponent,
              ),
          },
        ],
      },
      {
        path: 'organisms',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/organisms/organisms-overview.component').then(
                (m) => m.OrganismsOverviewComponent,
              ),
          },
          {
            path: 'annual-status-calendar',
            loadComponent: () =>
              import(
                './pages/organisms/annual-status-calendar-doc.component'
              ).then((m) => m.AnnualStatusCalendarDocComponent),
          },
          {
            path: 'data-table',
            loadComponent: () =>
              import('./pages/organisms/data-table-doc.component').then(
                (m) => m.DataTableDocComponent,
              ),
          },
          {
            path: 'entity-documents',
            loadComponent: () =>
              import('./pages/organisms/entity-documents-doc.component').then(
                (m) => m.EntityDocumentsDocComponent,
              ),
          },
          {
            path: 'document-folder-list',
            loadComponent: () =>
              import(
                './pages/organisms/document-folder-list-doc.component'
              ).then((m) => m.DocumentFolderListDocComponent),
          },
          {
            path: 'document-totals',
            loadComponent: () =>
              import('./pages/organisms/document-totals-doc.component').then(
                (m) => m.DocumentTotalsDocComponent,
              ),
          },
          {
            path: 'contact-list',
            loadComponent: () =>
              import('./pages/organisms/contact-list-doc.component').then(
                (m) => m.ContactListDocComponent,
              ),
          },
          {
            path: 'entity-action-log',
            loadComponent: () =>
              import('./pages/organisms/entity-action-log-doc.component').then(
                (m) => m.EntityActionLogDocComponent,
              ),
          },
          {
            path: 'app-header',
            loadComponent: () =>
              import('./pages/organisms/app-header-doc.component').then(
                (m) => m.AppHeaderDocComponent,
              ),
          },
          {
            path: 'app-sidebar',
            loadComponent: () =>
              import('./pages/organisms/app-sidebar-doc.component').then(
                (m) => m.AppSidebarDocComponent,
              ),
          },
          {
            path: 'bottom-navigation',
            loadComponent: () =>
              import('./pages/organisms/bottom-navigation-doc.component').then(
                (m) => m.BottomNavigationDocComponent,
              ),
          },
          {
            path: 'receipts',
            loadComponent: () =>
              import('./pages/organisms/receipts-doc.component').then(
                (m) => m.ReceiptsDocComponent,
              ),
          },
          {
            path: 'menu-sidebar',
            loadComponent: () =>
              import('./pages/organisms/menu-sidebar-doc.component').then(
                (m) => m.MenuSidebarDocComponent,
              ),
          },
          {
            path: 'menubar',
            loadComponent: () =>
              import('./pages/organisms/menubar-doc.component').then(
                (m) => m.MenubarDocComponent,
              ),
          },
          {
            path: 'title-bar',
            loadComponent: () =>
              import('./pages/organisms/title-bar-doc.component').then(
                (m) => m.TitleBarDocComponent,
              ),
          },
          {
            path: 'step-progress',
            loadComponent: () =>
              import('./pages/organisms/step-progress-doc.component').then(
                (m) => m.StepProgressDocComponent,
              ),
          },
          {
            path: 'step-validation',
            loadComponent: () =>
              import('./pages/organisms/step-validation-doc.component').then(
                (m) => m.StepValidationDocComponent,
              ),
          },
          {
            path: 'table-transfer',
            loadComponent: () =>
              import('./pages/organisms/table-transfer-doc.component').then(
                (m) => m.TableTransferDocComponent,
              ),
          },
          {
            path: 'task-panel',
            loadComponent: () =>
              import('./pages/organisms/task-panel-doc.component').then(
                (m) => m.TaskPanelDocComponent,
              ),
          },
          {
            path: 'tree',
            loadComponent: () =>
              import('./pages/organisms/tree-doc.component').then(
                (m) => m.TreeDocComponent,
              ),
          },
          {
            path: 'pie-chart',
            loadComponent: () =>
              import('./pages/organisms/pie-chart-doc.component').then(
                (m) => m.PieChartDocComponent,
              ),
          },
          {
            path: 'bar-chart',
            loadComponent: () =>
              import('./pages/organisms/bar-chart-doc.component').then(
                (m) => m.BarChartDocComponent,
              ),
          },
          {
            path: 'line-chart',
            loadComponent: () =>
              import('./pages/organisms/line-chart-doc.component').then(
                (m) => m.LineChartDocComponent,
              ),
          },
          {
            path: 'flow-diagram',
            loadComponent: () =>
              import('./pages/organisms/flow-diagram-doc.component').then(
                (m) => m.FlowDiagramDocComponent,
              ),
          },
          {
            path: 'image-carousel',
            loadComponent: () =>
              import('./pages/organisms/image-carousel-doc.component').then(
                (m) => m.ImageCarouselDocComponent,
              ),
          },
          {
            path: 'image-gallery',
            loadComponent: () =>
              import('./pages/organisms/image-gallery-doc.component').then(
                (m) => m.ImageGalleryDocComponent,
              ),
          },
          {
            path: 'image-mosaic',
            loadComponent: () =>
              import('./pages/organisms/image-mosaic-doc.component').then(
                (m) => m.ImageMosaicDocComponent,
              ),
          },
          {
            path: 'invoice-capture',
            loadComponent: () =>
              import('./pages/organisms/invoice-capture-doc.component').then(
                (m) => m.InvoiceCaptureDocComponent,
              ),
          },
          {
            path: 'portal-account-card',
            loadComponent: () =>
              import('./pages/organisms/portal-account-card-doc.component').then(
                (m) => m.PortalAccountCardDocComponent,
              ),
          },
          {
            path: 'promotion-card',
            loadComponent: () =>
              import('./pages/organisms/promotion-card-doc.component').then(
                (m) => m.PromotionCardDocComponent,
              ),
          },
          {
            path: 'property-summary-card',
            loadComponent: () =>
              import(
                './pages/organisms/property-summary-card-doc.component'
              ).then((m) => m.PropertySummaryCardDocComponent),
          },
          {
            path: 'video-playlist-dialog',
            loadComponent: () =>
              import(
                './pages/organisms/video-playlist-dialog-doc.component'
              ).then((m) => m.VideoPlaylistDialogDocComponent),
          },
        ],
      },
      {
        path: 'templates',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./pages/templates/templates-overview.component').then(
                (m) => m.TemplatesOverviewComponent,
              ),
          },
          {
            path: 'app-shell',
            loadComponent: () =>
              import('./pages/templates/app-shell-doc.component').then(
                (m) => m.AppShellDocComponent,
              ),
          },
          {
            path: 'app-layout',
            loadComponent: () =>
              import('./pages/templates/app-layout-doc.component').then(
                (m) => m.AppLayoutDocComponent,
              ),
          },
          {
            path: 'portal-layout',
            loadComponent: () =>
              import('./pages/templates/portal-layout-doc.component').then(
                (m) => m.PortalLayoutDocComponent,
              ),
          },
          {
            path: 'auth-login',
            loadComponent: () =>
              import('./pages/templates/auth-login-doc.component').then(
                (m) => m.AuthLoginDocComponent,
              ),
          },
          {
            path: 'portal-clientes-login',
            loadComponent: () =>
              import('./pages/templates/portal-clientes-login-doc.component').then(
                (m) => m.PortalClientesLoginDocComponent,
              ),
          },
          {
            path: 'portal-inmobiliarias-login',
            loadComponent: () =>
              import('./pages/templates/portal-inmobiliarias-login-doc.component').then(
                (m) => m.PortalInmobiliariasLoginDocComponent,
              ),
          },
          {
            path: 'portal-proveedores-login',
            loadComponent: () =>
              import('./pages/templates/portal-proveedores-login-doc.component').then(
                (m) => m.PortalProveedoresLoginDocComponent,
              ),
          },
          {
            path: 'proveedores-consulta-registro',
            loadComponent: () =>
              import(
                './pages/templates/proveedores-consulta-registro-doc.component'
              ).then((m) => m.ProveedoresConsultaRegistroDocComponent),
          },
          {
            path: 'welcome-panel',
            loadComponent: () =>
              import('./pages/templates/welcome-panel-doc.component').then(
                (m) => m.WelcomePanelDocComponent,
              ),
          },
        ],
      },
    ],
  },
];
